import React, { Component } from 'react';

// Import the CSS
import '../../scss/components/_form-control.scss';

export default class FormControl extends Component {
	render () {

		let classes = [ 'form-control' ];

		// Add additional classes based on the props
		if (this.props.direction) {
			classes.push(`form-control-${this.props.direction}`);
		}
		if (this.props.className) {
			classes.push(this.props.className);
		}
		if (this.props.hasError) {
			classes.push('form-control-error');
		}

		return (
			<div className={ classes.join(' ') }>
				{ this.props.children }
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/components/FormControl.js